<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="col-md-12 control" :data-test-id="dataTestId">
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <div v-if="config.value">
                <img v-bind="config" :alt="config.altText || 'Image'" :src="config.value" :class="config.cssClass"/>
            </div>
        </div>
    </div>
</template>

<script>
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    alt: {
        type: 'string',
        label: 'Alternative text'
    }
};

export const imageComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
};

export default imageComponent;
</script>
